import m1 from "./mbuziplus-programme";
import m2 from "./goat-economics";
import m3 from "./youth-women-families";
import m20 from "./hormones-milk-making";
import m25 from "./milk-testing-quality";
import m26 from "./milk-human-health";
import m10 from "./nutrition-fundamentals";
import m11 from "./forage-rations";
import m12 from "./herd-health";
import m13 from "./diseases-parasites";
import m16 from "./reproduction-breeding";
import m18 from "./artificial-insemination";
import m19 from "./kidding-kid-rearing";
import m21 from "./lactation-milking";
import m7 from "./housing-construction";
import m17 from "./genetics-selection";
import m34 from "./financial-literacy";
import m35 from "./roi-business-plan";
import m36 from "./livestock-insurance";
import m37 from "./loans-collateral";
import m6 from "./planning-site-law";
import m9 from "./buying-foundation-stock";
import m14 from "./welfare-handling";
import m15 from "./climate-productivity";
import m22 from "./animal-records";
import m24 from "./risk-biosecurity";
import m32 from "./compliance-licences";
import m8 from "./equipment-tools";
import m23 from "./farm-management";
import m27 from "./milk-processing";
import m28 from "./soaps-manure-products";
import m29 from "./transport-cold-chain";
import m30 from "./markets-branding";
import m31 from "./digital-selling";
import m33 from "./exporting-products";
import m38 from "./groups-cooperatives";
import m39 from "./farm-succession-growth";
import m40 from "./practicals-sessions";
import m41 from "./capstone-farm-plan";
import m42 from "./final-exam-guide";
/* Every module that uses the shared reader. Add the next module here. */
export const GENERIC = { [m1.id]: m1, [m2.id]: m2, [m3.id]: m3, [m20.id]: m20, [m25.id]: m25, [m26.id]: m26, [m10.id]: m10, [m11.id]: m11, [m12.id]: m12, [m13.id]: m13, [m16.id]: m16, [m18.id]: m18, [m19.id]: m19, [m21.id]: m21, [m7.id]: m7, [m17.id]: m17, [m34.id]: m34, [m35.id]: m35, [m36.id]: m36, [m37.id]: m37, [m6.id]: m6, [m9.id]: m9, [m14.id]: m14, [m15.id]: m15, [m22.id]: m22, [m24.id]: m24, [m32.id]: m32, [m8.id]: m8, [m23.id]: m23, [m27.id]: m27, [m28.id]: m28, [m29.id]: m29, [m30.id]: m30, [m31.id]: m31, [m33.id]: m33, [m38.id]: m38, [m39.id]: m39, [m40.id]: m40, [m41.id]: m41, [m42.id]: m42 };
export const itemsOf = (c) => c.lessons.length + 2; // lessons + quiz + journal
